export const theme = {
  mainGreen: '#96E885',
  grayBorder: 'rgb(155, 155, 155)',
  fontSize: {
    xxs: '1.2rem',
    xs: '1.4rem',
    s: '1.6rem',
    m: '2rem',
    l: '2.4rem',
    xl: '3.5rem',
    xxl: '4rem',
  },
};
